import React, {useEffect, useState} from 'react'
import {Link, useLocation, useParams} from 'react-router-dom'
import {KTIcon, KTSVG} from '../../../../_metronic/helpers'
import Select from 'react-select'
import {
  deleteCoordinate,
  deleteGeofencing,
  deleteJT,
  deleteParkingResponses,
  deleteResponses,
  getCoordinate,
  getGeofencing,
  getInterview,
  getJT,
  getParking,
  getProject,
  getResponseInterview,
  getResponseInterviewWithProject,
  getResponseParking,
} from '../_requests'
import {deleteChecklistResponse, getChecklist, getResponseChecklist} from '../_ChecklistRequest'
import {useSelector, useDispatch} from 'react-redux'
import {RootState} from '../../../redux/store'
import {setProjects} from '../../../redux/project/projectSlice'
import {deleteInterviewReport, setInterviewReport} from '../../../redux/report/interviewReport'
import {setInterviewData} from '../../../redux/interview/interviewSlice'
import {setGeofencingData} from '../../../redux/geofencing/geofencingSlice'
import {setJourneyTimeData} from '../../../redux/journeyTime/journeyTimeSlice'
import {setChecklistData} from '../../../redux/report/checklistReportSlice'
import {setCoordinates} from '../../../redux/coordinate/coordinateSlice'
import {setParkingData} from '../../../redux/report/parkingReportSlice'
import {setChecklist} from '../../../redux/checklist/checklistSlice'
import {setParking} from '../../../redux/parking/parkingSlice'
import Filter from '../../../utils/Filter'
import {useAuth} from '../../../modules/auth'

const ReportTable: React.FC = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const {projectId} = useParams()
  const {currentUser} = useAuth()
  const projectList = useSelector((state: RootState) => state.project.projects)
  const interviewDataList = useSelector(
    (state: RootState) => state.report.interviewReport.interviewData
  )
  const interview = useSelector((state: RootState) => state.interview.interviewData)
  const checklistData = useSelector(
    (state: RootState) => state.report.checklistReport.checklistData
  )
  const parkingDataList = useSelector((state: RootState) => state.report.parkingReport.parkingData)
  const geofencingData = useSelector((state: RootState) => state.geofencing.geofencingData)
  const journeyData = useSelector((state: RootState) => state.journeyTime.journeyTimeData)
  const coordinateData = useSelector((state: RootState) => state.coordinate.coordinates)
  const searchParams = new URLSearchParams(location.search)
  const value = searchParams.get('value')
  const [tableData, setTableData] = useState([])
  const [parkingTableData, setParkingTableData] = useState([])
  const [ChecklistTableData, setChecklistTableData] = useState([])
  const [coordinateTableData, setCoordinateTableData] = useState([])
  const [geofencingTableData, setGeofencingTableData] = useState([])
  const [journeyTableData, setJourneyTableData] = useState([])
  const checklist = useSelector((state: RootState) => state.checkList.checklistData)
  const parking = useSelector((state: RootState) => state.parking.parkingData)
  const [deleteid, setdeleteid] = useState<string>('')
  const [deleteType, setDeleteType] = useState('response')
  const [totalReponse, setTotalReponse] = useState(0)
  const [searchTerm, setSearchTerm] = useState('')
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  // const [selectedTasks, setSelectedTasks] = useState({value: value, label: value})

  const fetchData = async () => {
    if (value) {
      if (projectList.length === 0) {
        const projectResponse = await getProject()
        dispatch(setProjects(projectResponse))
      }
      switch (value) {
        case 'interview':
          if (interviewDataList) {
            const interviewResponse = await getResponseInterviewWithProject(
              '',
              '',
              '',
              projectId,
              currentUser?.profileType === 'admin' ? 'all' : currentUser?.fullName
            )
            setTableData(interviewResponse)
            dispatch(setInterviewReport(interviewResponse))
            setTotalReponse(interviewResponse.length)
          } else {
            setTableData(interviewDataList)
            setTotalReponse(interviewDataList.length)
          }
          // if (interview.length === 0) {
          //   const interviewData = await getInterview()
          //   dispatch(setInterviewData(interviewData))
          // }
          break
        case 'geofencing':
          if (geofencingData.length === 0) {
            const geofencingResponse = await getGeofencing()
            setGeofencingTableData(geofencingResponse)
            dispatch(setGeofencingData(geofencingResponse))
            setTotalReponse(geofencingResponse.length)
          } else {
            setGeofencingTableData(geofencingData)
            setTotalReponse(geofencingData.length)
          }
          break
        case 'journeytime':
          if (journeyData.length === 0) {
            const journeyResponse = await getJT()
            setJourneyTableData(journeyResponse)
            dispatch(setJourneyTimeData(journeyResponse))
            setTotalReponse(journeyResponse.length)
          } else {
            setJourneyTableData(journeyData)
            setTotalReponse(journeyData.length)
          }
          break
        case 'checklist':
          if (checklistData.length === 0) {
            const checklistResponse = await getResponseChecklist()
            setChecklistTableData(checklistResponse)
            dispatch(setChecklistData(checklistResponse))
            setTotalReponse(checklistResponse.length)
          } else {
            setChecklistTableData(checklistData)
            setTotalReponse(checklistData.length)
          }
          if (checklist.length === 0) {
            const checklistsResponse = await getChecklist()
            dispatch(setChecklist(checklistsResponse))
          }
          break
        case 'coordinate':
          if (coordinateData.length === 0) {
            const coordinateResponse = await getCoordinate()
            setCoordinateTableData(coordinateResponse)
            dispatch(setCoordinates(coordinateResponse))
            setTotalReponse(coordinateResponse.length)
          } else {
            setCoordinateTableData(coordinateData)
            setTotalReponse(coordinateData.length)
          }
          break
        case 'parking':
          if (parkingDataList.length === 0) {
            const parkingResponse = await getResponseParking()
            setParkingTableData(parkingResponse)
            dispatch(setParkingData(parkingResponse))
            setTotalReponse(parkingResponse.length)
          } else {
            setParkingTableData(parkingDataList)
            setTotalReponse(parkingDataList.length)
          }
          if (parking.length === 0) {
            const parkingData = await getParking()
            dispatch(setParking(parkingData))
          }
          break
        default:
          break
      }
    }
  }

  useEffect(() => {
    fetchData()
  }, [value, projectId])

  useEffect(() => {
    setTableData(interviewDataList)
  }, [interviewDataList])

  const formatCreatedAt = (createdAt: string | undefined) => {
    if (!createdAt) return 'N/A'
    const formattedDate = new Date(createdAt).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    })
    return formattedDate
  }

  const handleDelete = async () => {
    let res
    if (deleteType === 'response') {
      res = await deleteResponses(deleteid)

      if (res) {
        dispatch(deleteInterviewReport(deleteid))
      }
    } else if (deleteType === 'parking') {
      res = await deleteParkingResponses(deleteid)
    } else if (deleteType === 'coordinate') {
      res = await deleteCoordinate(deleteid)
    } else if (deleteType === 'geofencing') {
      res = await deleteGeofencing(deleteid)
    } else if (deleteType === 'journey') {
      res = await deleteJT(deleteid)
    }
    fetchData()
    if (res !== null) {
      const closeModalButton = document.getElementById('closeModalButtondelete')
      if (closeModalButton) {
        closeModalButton.click()
      }
    }
  }

  const handleDeleteChecklist = async () => {
    const res = await deleteChecklistResponse(deleteid)
    fetchData()
    if (res !== null) {
      const closeModalButton = document.getElementById('closeModalButtondeleteChecklist')
      if (closeModalButton) {
        closeModalButton.click()
      }
    }
  }

  const getFilteredData = async () => {
    switch (value) {
      case 'interview':
        const filteredData = await getResponseInterviewWithProject(
          searchTerm,
          startDate,
          endDate,
          projectId,
          currentUser?.profileType === 'admin' ? 'all' : currentUser?.fullName
        )
        setTableData(filteredData)
        setTotalReponse(filteredData.length)
        break
      case 'checklist':
        const checklistFilteredData = await getResponseChecklist(startDate, endDate)
        setChecklistTableData(checklistFilteredData)
        setTotalReponse(checklistFilteredData.length)
        break
      default:
        break
    }
  }

  const filterSearchTerm = async () => {
    switch (value) {
      case 'checklist':
        const checklistFilteredData = checklist.filter((item) => {
          return item.CheckListName.toLowerCase().includes(searchTerm.toLowerCase())
        })
        const checkListIds = checklistFilteredData.map((item) => item._id)

        const filteredChecklistData = checklistData.filter((item) => {
          return checkListIds.includes(item.checklistId)
        })

        setChecklistTableData(filteredChecklistData)
        setTotalReponse(filteredChecklistData.length)
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (searchTerm !== '' && value !== 'checklist') {
      getFilteredData()
    } else {
      if (searchTerm !== '') {
        filterSearchTerm()
      }
    }
  }, [searchTerm])

  useEffect(() => {
    if (startDate && endDate) {
      getFilteredData()
    }
  }, [startDate, endDate])

  const resetFilter = () => {
    setSearchTerm('')
    setStartDate(null)
    setEndDate(null)
    switch (value) {
      case 'interview':
        setTableData(interviewDataList)
        setTotalReponse(interviewDataList.length)
        break
      case 'checklist':
        setChecklistTableData(checklistData)
        setTotalReponse(checklistData.length)
        break
      default:
        break
    }
  }

  return (
    <>
      {(value === 'interview' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>Interview</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-200px'>Name</th>
                    <th className='min-w-100px text-center'>Total Responses</th>
                    {/* <th className='min-w-150px'>Project</th> */}
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/${data?.interviewId?._id}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'
                          >
                            {/* {
                              interview.filter((item, i) => {
                                return item._id === data.interviewId
                              })[0]?.interviewName
                            } */}
                            {data?.interviewId?.interviewName}
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold text-center'>{data?.answers || 0}</p>
                        </td>
                        {/* <td>
                          <p className='font-semibold'>
                            {
                              projectList.filter((item, i) => {
                                return (
                                  item._id ===
                                  interview.filter((item2, i) => {
                                    return item2._id === data.interviewId
                                  })[0]?.project
                                )
                              })[0]?.name
                            }
                            {data?.interviewId?.project?.[0]?.name}
                          </p>
                        </td> */}

                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data?.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_interview'
                              onClick={() => {
                                setdeleteid(data?.interviewId?._id)
                                setDeleteType('response')
                              }}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
          <div className='modal fade' tabIndex={-1} id='kt_modal_interview'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title'>Delete</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>

                <div className='modal-body'>
                  <h3> Are you sure you want to delete</h3>
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    data-bs-dismiss='modal'
                    id='closeModalButtondelete'
                  >
                    No
                  </button>
                  <button type='button' className='btn btn-primary' onClick={handleDelete}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {(value === 'checklist' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8 mt-4'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>CheckList</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-300px'>Name</th>
                    <th className='min-w-100px text-center'>Total Responses</th>
                    <th className='min-w-150px'>Project</th>
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {ChecklistTableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/checklist/${data.checklistId}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'
                          >
                            {
                              checklist.filter((item, i) => {
                                return item._id === data.checklistId
                              })[0]?.CheckListName
                            }
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold text-center'>{data?.answers || 0}</p>
                        </td>
                        <td>
                          <p className='font-semibold'>
                            {
                              projectList.filter((item, i) => {
                                return (
                                  item._id ===
                                  checklist.filter((item2, i) => {
                                    return item2._id === data.checklistId
                                  })[0]?.project
                                )
                              })[0]?.name
                            }
                          </p>
                        </td>
                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_checklist'
                              onClick={() => setdeleteid(data._id)}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
          <div className='modal fade' tabIndex={-1} id='kt_modal_checklist'>
            <div className='modal-dialog'>
              <div className='modal-content'>
                <div className='modal-header'>
                  <h5 className='modal-title'>Delete</h5>
                  <div
                    className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr061.svg'
                      className='svg-icon svg-icon-2x'
                    />
                  </div>
                </div>

                <div className='modal-body'>
                  <h3> Are you sure you want to delete</h3>
                </div>

                <div className='modal-footer'>
                  <button
                    type='button'
                    className='btn btn-light'
                    data-bs-dismiss='modal'
                    id='closeModalButtondeleteChecklist'
                  >
                    No
                  </button>
                  <button type='button' className='btn btn-primary' onClick={handleDeleteChecklist}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {(value === 'parking' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>Parking Occupancy</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-300px'>Name</th>
                    <th className='min-w-100px text-center'>Total Responses</th>
                    <th className='min-w-150px'>Project</th>
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {parkingTableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/parking/${data.parkingId}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 capitalize'
                          >
                            {
                              parking.filter((item, i) => {
                                return item._id === data.parkingId
                              })[0]?.parkingName
                            }
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold text-center'>{data?.surveys || 0}</p>
                        </td>
                        <td>
                          <p className='font-semibold'>
                            {
                              projectList.filter((item, i) => {
                                return (
                                  item._id ===
                                  parking.filter((item2, i) => {
                                    return item2._id === data.parkingId
                                  })[0]?.project
                                )
                              })[0]?.name
                            }
                          </p>
                        </td>
                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_interview'
                              onClick={() => {
                                setdeleteid(data._id)
                                setDeleteType('parking')
                              }}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      )}

      {(value === 'geofencing' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>Geo Fencing</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-300px'>Name</th>
                    <th className='min-w-200px'>Project</th>
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {geofencingTableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/geofencing/${data._id}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 capitalize'
                          >
                            {data?.geoFencingName}
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold'>{data?.project?.name}</p>
                        </td>
                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_interview'
                              onClick={() => {
                                setdeleteid(data._id)
                                setDeleteType('geofencing')
                              }}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      )}

      {(value === 'journeytime' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>Journey Time</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-300px'>Name</th>
                    <th className='min-w-200px'>Project</th>
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {journeyTableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/journey/${data._id}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 capitalize'
                          >
                            {data.name}
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold'>{data?.project?.name}</p>
                        </td>
                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_interview'
                              onClick={() => {
                                setdeleteid(data._id)
                                setDeleteType('journey')
                              }}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      )}

      {(value === 'coordinate' || value === 'all') && (
        <div className='card card-xl-stretch mb-xl-8'>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <div className='flex flex-col md:flex-row items-center gap-4'>
                <span className='card-label fw-bold fs-3 mb-1'>Co-ordinate</span>
                <Filter
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  startDate={startDate}
                  setStartDate={setStartDate}
                  endDate={endDate}
                  setEndDate={setEndDate}
                  resetFilter={resetFilter}
                />
              </div>
            </h3>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              <table className='table align-middle gs-0 gy-3'>
                <thead>
                  <tr className='fw-bold text-muted bg-light'>
                    <th className='min-w-50px ps-4 rounded-start'>No.</th>
                    <th className='min-w-300px'>Name</th>
                    <th className='min-w-200px'>Project</th>
                    <th className='min-w-100px'>Created On</th>
                    <th className='text-end rounded-end'></th>
                  </tr>
                </thead>
                <tbody>
                  {coordinateTableData.map((data, index) => {
                    return (
                      <tr key={data._id}>
                        <td>
                          <p className='font-semibold ps-4'>{totalReponse - index}</p>
                        </td>
                        <td>
                          <Link
                            to={`/reports/coordinate/${data._id}`}
                            className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 capitalize'
                          >
                            {data.coordinateName}
                          </Link>
                        </td>
                        <td>
                          <p className='font-semibold'>
                            {
                              // projectList.filter((item, i) => {
                              //   return (
                              //     item._id ===
                              //     parking.filter((item2, i) => {
                              //       return item2._id === data.parkingId
                              //     })[0]?.project
                              //   )
                              // })[0]?.name
                              data.project?.name
                            }
                          </p>
                        </td>
                        <td>
                          <p className='font-semibold'>{formatCreatedAt(data.createdAt)}</p>
                        </td>
                        {currentUser?.profileType === 'admin' && (
                          <td className='text-end'>
                            <div
                              className='cursor-pointer rounded-md bg-gray-200 p-2 flex items-center justify-center'
                              data-bs-toggle='modal'
                              data-bs-target='#kt_modal_interview'
                              onClick={() => {
                                setdeleteid(data._id)
                                setDeleteType('coordinate')
                              }}
                            >
                              <KTIcon iconName='trash' className='fs-3' />
                            </div>
                          </td>
                        )}
                      </tr>
                    )
                  })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ReportTable
